import Home from '../views/page/Home';
import SignIn from '../views/page/auth/SignIn';
import SignUp from '../views/page/auth/SignUp';
import NotFound from '../views/page/pageNotFound/NotFound';
import AboutPage from '../views/page/about/AboutPage';
import AboutDescript from '../views/page/about/AboutDescript';
import KenyaEducationInfo from '../views/page/about/KenyaEducationInfo';
import KenyaWorkflow from '../views/page/about/KenyaWorkflow';
import GuidePage from '../views/k_guidePage/GuidePage';
import GdFree from '../views/k_guidePage/GdFree';
import GdUniversity from '../views/k_guidePage/GdUniversity';
import UnivPublic from '../views/k_guidePage/gdUniversitys/UnivPublic';
import UnivPrivate from '../views/k_guidePage/gdUniversitys/UnivPrivate';
import GdPremium from '../views/k_guidePage/GdPremium';
import GdPremiumPlus from '../views/k_guidePage/GdPremiumPlus';
import StudentHousing from '../views/k_guidePage/accommodation/StudentHousing';
import StudentAdress from '../views/k_guidePage/accommodation/StudentAdress';
import Cart from '../views/k_guidePage/cart/Cart';
import Contact from '../views/k_guidePage/contact/Contact';
import PaymentForm from '../features/payment/PaymentForm';
import ChoiceCountry from '../views/k_guidePage/countryChoice/ChoiceCountry';
import ProfilUser from '../dashboard/views/page/profil/ProfilUser';
import Test from '../components/test/Test';
import RgByCenter from '../views/k_guidePage/gdByRegion/rgByCenter/RgByCenter';
import RgByEst from '../views/k_guidePage/gdByRegion/rgByEst/RgByEst';
import RgByNord from '../views/k_guidePage/gdByRegion/rgByNord/RgByNord';
import RgByOuest from '../views/k_guidePage/gdByRegion/rgByOuest/RgByOuest';
import RgBySud from '../views/k_guidePage/gdByRegion/rgBySud/RgBySud';


export const publicRoutes = [
  { path: "/", element: <Home /> },
  { path: "/mksp/login", element: <SignIn /> },
  { path: "/mksp/register", element: <SignUp /> },
  { path: "/mksp/about", element: <AboutPage /> },
  { path: "/mksp/about-description", element: <AboutDescript /> },
  { path: "/mksp/kenya-education-info", element: <KenyaEducationInfo /> },
  { path: "/mksp/workflow", element: <KenyaWorkflow /> },
  { path: "/mksp/contact", element: <Contact /> },
  { path: "/mksp/test/prod", element: <Test /> },
  { path: "/mksp/guide", element: <GuidePage /> },
  { path: "/mksp/guide/all-university", element: <GdFree /> },
  { path: "/mksp/guide/university", element: <GdUniversity /> },
  { path: "/mksp/guide/university-public", element: <UnivPublic /> },
  { path: "/mksp/guide/university-private", element: <UnivPrivate /> },
  { path: "/mksp/maxicatch", element: <PaymentForm /> },
  { path: "/mksp/choice-country", element: <ChoiceCountry /> },
  { path: "/mksp/profil", element: <ProfilUser /> },
  { path: "*", element: <NotFound /> },
];

export const premiumRoutes = [
  { path: "/mksp/guide/premium", element: <GdPremium /> },
  
  // Route By Regions Country 
  { path: "/mksp/guide/premium-rg-center", element: <RgByCenter /> },
  { path: "/mksp/guide/premium-rg-est", element: <RgByEst/> },
  { path: "/mksp/guide/premium-rg-nord", element: <RgByNord /> },
  { path: "/mksp/guide/premium-rg-ouest", element: <RgByOuest /> },
  { path: "/mksp/guide/premium-rg-sud", element: <RgBySud /> },

  { path: "/mksp/guide/premium-plus", element: <GdPremiumPlus /> },
  { path: "/mksp/StudentHousing", element: <StudentHousing /> },
  { path: "/mksp/Student-housing-adress", element: <StudentAdress /> },
  { path: "/mksp/Cart", element: <Cart /> },
];


